import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { HttpHandlerArgModel } from "@core/data/http.service";
import { BaseMoghimProxyService, MoghimApiProxyResult } from "@core/data/BaseMoghimProxyService";
import { User } from "@pages/auth/_models/user";
import { Observable } from "rxjs";

@Injectable()
export class MoghimCore2010Proxy extends BaseMoghimProxyService {
    constructor(http: HttpClient, baseSettings?: HttpHandlerArgModel) {
        super(http,'MoghimCore2010',baseSettings);
    }

    public GetCommissionsList(input : TCore.GetCommissionsListInputModel) : Observable<MoghimApiProxyResult<Array<TCore.CommissionsListItem>>>
    {
        return this.Post<Array<TCore.CommissionsListItem>>({
            model : input,
            endPointId : 'commission-list'
        });
    }

    public ManageCommissions(input : Array<TCore.CommissionItem>) : Observable<MoghimApiProxyResult<any>>
    {
        return this.Post<any>({
            model : input,
            endPointId : 'commission-manage'
        });
    }

    public GetCustomersList() : Observable<MoghimApiProxyResult<Array<TCore.CommissionCustomerItem>>>
    {
        return this.Post<Array<TCore.CommissionCustomerItem>>({
            // model : input,
            endPointId : 'commission-customer'
        });
    }

    public AgencyLogin(input : TCore.AgencyLoginInputModel) : Observable<any>
    {
        return this.PostForSingle<User>({
            model : input,
            needToken: true,
            token: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwOi8vd3d3LmF1dGhlbnRpY2F0aW9uLm1vZ2hpbTI0LmNvbSIsImlhdCI6MTU1MDY3MzA1NiwibmJmIjoxNTUwNjczMDU2LCJleHAiOjE2MzcwNzMwNTYsImp0aSI6IjU3OTM2MTI0NWI1MTQwZWU5ZDA2ZDViZGRmZTQ4ZjQ2IiwiaWQiOiIwNjkxNzA1Mi05ZjdhLTRiMDEtYWYzZS1jN2E5YmRmMmNmYjUiLCJ0aXRsZSI6Itii2LLYp9mG2LMg2YfYp9uMINmF2YLbjNmFIiwiY3VzdG9tZXJfY29kZSI6Ik1vZ2hpbUNsaWVudEFnZW5jeSIsInJlcXVlc3RfYXQiOiIyMDE5LzAyLzIwIDE0OjMwOjU2IiwiZXhwaXJlZF9hdCI6IjIwMjEvMTEvMTYgMTQ6MzA6NTYiLCJleHRyYV9wYXJhbWV0ZXIiOiIifQ.qBsmXoDFDvePdlls3fsDv0Hgk_WN8fx4QipSePsRtrKcBgsCsZ7fNTtAtg_XxIyfQS9ED0F-kuLpHyBK2e15YsJ3DTNTcrnazpC9iFIvBV_eFZmdTCNxZRqRlsFQPrDPUYOjmlLBnIalQWaH3OnWIge978u_VUf-dm540i6pz1n4QhUWlCrAbu64e7OuVXRandUDd8nxi3Ni_zneJIH1g-uoNDFEmr_7r9S1TIB-KOiNRZg0G-lnRJDcVj3s5eX1LvtDiR7olpVUwGUCyn3ln8yDhjXNg-3S4mf3fZzypDSatewbleEyjNVaTP9BNgxvbtJn_JoOnv55jYwPVnfHHw',
            endPointId : 'online-agency-login'
        });
    }
}